import { tKey } from 'ember-intl';

/** Number of variations in translations used for Visibility Boost's `low_otb_decrease_price_rec` reason */
export const NUMBER_OF_DECREASE_PRICE_VARIATIONS = 6;

/** Number of variations in translations used for Visibility Boost's `low_otb_no_price_rec` reason */
export const NUMBER_OF_NO_PRICE_VARIATIONS = 5;

/** List of possible reasons of marketing recommendations */
export const RecommendationsReasons = {
  LOW_OTB_DECREASE_PRICE_REC: 'low_otb_decrease_price_rec',
  LOW_OTB_NO_PRICE_REC: 'low_otb_no_price_rec',
} as const;

export const VARIATION_DEFAULT = 0;
export const VARIATION_ONE = 1;
export const VARIATION_TWO = 2;
export const VARIATION_THREE = 3;
export const VARIATION_FOUR = 4;
export const VARIATION_FIVE = 5;

export type LOW_OTB_DECREASE_PRICE_OPTIONS =
  | typeof VARIATION_DEFAULT
  | typeof VARIATION_ONE
  | typeof VARIATION_TWO
  | typeof VARIATION_THREE
  | typeof VARIATION_FOUR
  | typeof VARIATION_FIVE;

export const LOW_OTB_DECREASE_PRICE_REC_TRANSLATION_KEYS: Record<
  LOW_OTB_DECREASE_PRICE_OPTIONS,
  string
> = {
  [VARIATION_DEFAULT]: tKey(
    'visibility_boost.modal.banner.body.low_otb_decrease_price_rec',
  ),
  [VARIATION_ONE]: tKey(
    'visibility_boost.modal.banner.body.low_otb_decrease_price_rec_1',
  ),
  [VARIATION_TWO]: tKey(
    'visibility_boost.modal.banner.body.low_otb_decrease_price_rec_2',
  ),
  [VARIATION_THREE]: tKey(
    'visibility_boost.modal.banner.body.low_otb_decrease_price_rec_3',
  ),
  [VARIATION_FOUR]: tKey(
    'visibility_boost.modal.banner.body.low_otb_decrease_price_rec_4',
  ),
  [VARIATION_FIVE]: tKey(
    'visibility_boost.modal.banner.body.low_otb_decrease_price_rec_5',
  ),
};

export type LOW_OTB_NO_PRICE_OPTIONS =
  | typeof VARIATION_DEFAULT
  | typeof VARIATION_ONE
  | typeof VARIATION_TWO
  | typeof VARIATION_THREE
  | typeof VARIATION_FOUR;

export const LOW_OTB_NO_PRICE_REC_TRANSLATION_KEYS: Record<
  LOW_OTB_NO_PRICE_OPTIONS,
  string
> = {
  [VARIATION_DEFAULT]: tKey(
    'visibility_boost.modal.banner.body.low_otb_no_price_rec',
  ),
  [VARIATION_ONE]: tKey(
    'visibility_boost.modal.banner.body.low_otb_no_price_rec_1',
  ),
  [VARIATION_TWO]: tKey(
    'visibility_boost.modal.banner.body.low_otb_no_price_rec_2',
  ),
  [VARIATION_THREE]: tKey(
    'visibility_boost.modal.banner.body.low_otb_no_price_rec_3',
  ),
  [VARIATION_FOUR]: tKey(
    'visibility_boost.modal.banner.body.low_otb_no_price_rec_4',
  ),
};
